import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    product_types: [],
    product_typesCount: 0,
    product_type: {},
    product_typeSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getProduct_types(state) {
      return state.product_types
    },
    getProduct_typesCount(state) {
      return state.product_typesCount
    },
    getProduct_type(state) {
      return state.product_type
    },
    getProduct_typeSaveStatus(state) {
      return state.product_typeSave
    },
  },
  mutations: {
    PRODUCT_TYPES_LIST(state, data) {
      state.product_types = data
    },
    PRODUCT_TYPE_VIEW(state, data) {
      state.product_type = data
    },
    PRODUCT_TYPES_COUNT(state, data) {
      state.product_typesCount = data
    },
    PRODUCT_TYPE_SAVE(state, data) {
      state.product_typeSave = data
    },
  },
  actions: {
    product_typesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/defines/product_types/getData', data)
        .then(response => {
          commit('PRODUCT_TYPES_LIST', response.data.data)
          commit('PRODUCT_TYPES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    product_typeView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'product_types.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/defines/product_types/getData', data)
        .then(response => {
          commit('PRODUCT_TYPE_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    product_typeSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/defines/product_types/saveData', data)
        .then(response => {
          commit('PRODUCT_TYPE_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
